import React from "react";
import { FooterText, StyledFooter } from "./Footer.styles";
import { TEAM_NAME } from "../../utils/info";

const Footer = () => {
    return (
        <StyledFooter>
            <FooterText>
                {TEAM_NAME} &copy; 2021 {`- ${new Date().getFullYear()}`}.
                Wszelkie prawa zastrzeżone.
            </FooterText>
        </StyledFooter>
    );
};

export default Footer;
